import Nullstack from 'nullstack';
export default function IconTournament({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-tournament",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "4",
    cy: "4",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "20",
    cy: "10",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "4",
    cy: "12",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "4",
    cy: "20",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M6 12h3a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-3"
  }), "   ", Nullstack.element("path", {
    d: "M6 4h7a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-2"
  }), "   ", Nullstack.element("path", {
    d: "M14 10h4"
  }), " ");
}